// React app disabled - using static HTML in public/index.html
// This file is intentionally minimal to let public/index.html take over

console.log('Static HTML mode enabled');
